import React from 'react';
import { EMPTY } from 'rxjs';
import { FormattedMessage } from 'react-intl';

import { DocumentType } from '../../../enums/document-type';

export const shipmentManifest = {
  id: DocumentType.ShipmentManifest.identifier,

  getDownloadStartedProps: () => ({
    title: (
      <FormattedMessage
        defaultMessage='Downloading Shipment Manifest...'
        description='printEpics.downloadShipmentManifestStartedTitle'
        id='7foZte'
      />
    ),
    content: (
      <FormattedMessage
        defaultMessage='Shipment Manifest Download Started.'
        description='printEpics.downloadShipmentManifestStartedContent'
        id='dtyoQ2'
      />
    ),
  }),

  getDownloadCompletedProps: () => ({
    title: (
      <FormattedMessage
        defaultMessage='Downloading Shipment Manifest...'
        description='printEpics.downloadShipmentManifestCompletedTitle'
        id='Tdt+Wq'
      />
    ),
    content: (
      <FormattedMessage
        defaultMessage='Shipment Manifest Download Completed.'
        description='printEpics.downloadShipmentManifestCompletedContent'
        id='afkL2C'
      />
    ),
  }),

  getPrintedSuccessNotificationProps: (docCount, printerName) => ({
    title: (
      <FormattedMessage
        defaultMessage='Printing Shipment Manifest...'
        description='printEpics.printingShipmentManifestSuccessTitle'
        id='nNt9dC'
      />
    ),
    content: (
      <FormattedMessage
        defaultMessage='Shipment Manifest sent to {printerName}.'
        description='printEpics.printingShipmentManifestSuccessContent'
        id='nv4vic'
        values={{
          printerName,
        }}
      />
    ),
  }),

  getPrintedSuccessObservable: () => {
    return EMPTY;
  },
};
